import { useTranslation } from 'react-i18next'

// local imports
import calendarLoading from 'assets/icons/loading-calendar.png'
import useGetFavoriteLocations from './use-get-locations'
import Loader from 'components/ui/Loader'
import NoContent from 'components/ui/NoContent'
import FavoriteListItem from './ListItem'
import { ListWrapper, TabPanelWrapper } from '../styled'

export default function FavoriteFirmLocations() {
  const { t } = useTranslation()
  const { list, setList, loading } = useGetFavoriteLocations(false)

  if (loading) return <ListLoader />

  return (
    <TabPanelWrapper>
      {!!list?.length ? (
        <ListWrapper>
          {list?.map((li) => (
            <FavoriteListItem key={li.id} item={li} setList={setList} />
          ))}
        </ListWrapper>
      ) : (
        <NoContent message={t('homepage.favorite-locations-not-found')} />
      )}
    </TabPanelWrapper>
  )
}

function ListLoader() {
  return (
    <div className="py-5 my-4">
      <Loader src={calendarLoading} />
    </div>
  )
}
